<script setup>
import {ref, onBeforeMount} from "vue"
import {clubUserAuditStateEnum} from "@/enum/clubUserAuditStateEnum.js"
const props = defineProps({
  state: {
    required: true,
    type: String,
    default: "INIT"
  }
})

// 执行订单判断
onBeforeMount(() => {
  handleEnum()
})

// 展示的文本类型
const textType = ref("info")
// 状态名称
const stateName = ref("未知状态")
// 状态枚举
const state = clubUserAuditStateEnum

// 根据枚举返回订单状态
const handleEnum = () => {
  try {
    const order = state.find(res => res.stateId === props.state)
    stateName.value = order.stateName ? order.stateName : "未知状态"
    switch (props.state) {
      case "PENDING":
        textType.value = "primary"
        break
      case "APPROVED":
        textType.value = "success"
        break
      case "REJECTED":
        textType.value = "danger"
        break
    }
  } catch (e) {
    console.log(e)
  }
}
</script>

<template>
  <el-text :type="textType" v-text="stateName"></el-text>
</template>

<style scoped>

</style>
